export default class WindowApp {
	constructor() {
		// Example
		// this.scrollPos = new Subject(0);
	}
}
